import { ArrowForwardIcon } from "@chakra-ui/icons";
import { Button, Link, Text } from "@chakra-ui/react";
import VueContext from "@iloq/shared-react/vueContext";
import { PartnerTier, PartnerTierType } from "@iloq/shared/IPartnerInfo";
import { ReactNode, SyntheticEvent, useContext } from "react";
import { FormattedMessage } from "react-intl";

export function StatisticsButton({ tier }: { tier?: PartnerTierType }): ReactNode {
  const context = useContext(VueContext);
  const $router = context.$router;

  if (!tier || tier === PartnerTier.NONE) {
    return null;
  }

  const text = (
    <Text noOfLines={1}>
      <FormattedMessage
        id="partnerProgram.hero.statistics"
        values={{
          tier,
          b: (chunks) => <strong style={{ textTransform: "capitalize" }}>{chunks}</strong>,
        }}
      />
    </Text>
  );

  const tierValues: {
    background: string;
    color: string;
    border: string;
    hover: Record<string, string>;
  } = {
    background: "brand.purple",
    color: "white",
    border: "1px solid white",
    hover: { color: "white", boxShadow: "0 0 2px 2px #fff", textDecoration: "none" },
  };

  if (tier === PartnerTier.PLATINUM) {
    tierValues.background =
      "radial-gradient(40% 180% at 25% 75%, #F5F4F4 0%, rgba(133, 133, 133, 0.56) 100%), #FFF;";
    tierValues.hover = {
      background:
        "radial-gradient(115% 521% at 25% 75%, #FFF 0%, rgba(133, 133, 133, 0.56) 100%), #FFF;",
      color: "brand.purple",
      textDecoration: "none",
    };
    tierValues.color = "brand.purple";
    tierValues.border = "inherit";
  }

  if (tier === PartnerTier.GOLD) {
    tierValues.background = "brand.beige";
    tierValues.color = "brand.purpleDark";
    tierValues.hover = { background: "brand.beigeLight", textDecoration: "none" };
    tierValues.border = "inherit";
  }

  return (
    <Button
      variant="pill"
      as={Link}
      href="/partner_program/dashboard"
      onClick={(e: SyntheticEvent) => {
        e.preventDefault();
        $router.history?.push("/partner_program/dashboard");
      }}
      rightIcon={<ArrowForwardIcon />}
      background={tierValues.background}
      _hover={tierValues.hover}
      paddingX="2xl"
      color={tierValues.color}
      border={tierValues.border}
      data-cy="partner-program-statistics-button"
    >
      {text}
    </Button>
  );
}
